import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Facebook, Twitter, Instagram } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { cn } from '../../lib/utils';
export function Footer() {
  const currentYear = new Date().getFullYear();
  const {
    t,
    isRTL
  } = useLanguage();
  return <footer className="bg-gray-900 text-gray-300" data-id="element-22">
      <div className="container mx-auto px-4 md:px-6 py-8 md:py-10" data-id="element-23">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8" data-id="element-24">
          {/* Brand Info */}
          <div className="space-y-3" data-id="element-25">
            <div className="flex items-center gap-3" data-id="element-26">
              <img src="https://cdn.magicpatterns.com/uploads/aA4YJyXsgBXST459kH7g7H/New_Logo_bg_remove.png" alt="KMA UK Logo" className="h-14 w-14 object-contain" data-id="element-27" />
              <span className="text-xl font-serif font-bold text-white" data-id="element-28">
                KMA UK
              </span>
            </div>
            <p className="text-sm leading-relaxed text-gray-400" data-id="element-29">
              {t('footer.description')}
            </p>
          </div>

          {/* Quick Links */}
          <div data-id="element-30">
            <h3 className="text-white font-serif font-semibold mb-3" data-id="element-31">
              {t('footer.quickLinks')}
            </h3>
            <ul className="space-y-2 text-sm" data-id="element-32">
              <li data-id="element-33">
                <Link to="/about" className="hover:text-primary-400 transition-colors" data-id="element-34">
                  {t('nav.about')}
                </Link>
              </li>
              <li data-id="element-35">
                <Link to="/membership" className="hover:text-primary-400 transition-colors" data-id="element-36">
                  {t('nav.membership')}
                </Link>
              </li>
              <li data-id="element-37">
                <Link to="/events" className="hover:text-primary-400 transition-colors" data-id="element-38">
                  {t('nav.events')}
                </Link>
              </li>
              <li data-id="element-39">
                <Link to="/charity" className="hover:text-primary-400 transition-colors" data-id="element-40">
                  {t('nav.charity')}
                </Link>
              </li>
              <li data-id="element-41">
                <Link to="/team" className="hover:text-primary-400 transition-colors" data-id="element-42">
                  {t('nav.team')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-43">
            <h3 className="text-white font-serif font-semibold mb-3" data-id="element-44">
              {t('footer.contactUs')}
            </h3>
            <ul className="space-y-2 text-sm" data-id="element-45">
              <li className="flex items-start space-x-3" data-id="element-46">
                <MapPin className={cn('h-5 w-5 text-primary-500 shrink-0', isRTL && 'ml-3')} data-id="element-47" />
                <span data-id="element-48">
                  17 Honeybourne,
                  <br data-id="element-49" />
                  Bishop's Stortford, CM23 4EF
                </span>
              </li>
              <li className="flex items-center space-x-3" data-id="element-50">
                <Mail className={cn('h-5 w-5 text-primary-500 shrink-0', isRTL && 'ml-3')} data-id="element-51" />
                <a href="mailto:info@kmauk.org" className="hover:text-primary-400" data-id="element-52">
                  info@kmauk.org
                </a>
              </li>
            </ul>
          </div>

          {/* Social & Legal */}
          <div data-id="element-53">
            <h3 className="text-white font-serif font-semibold mb-3" data-id="element-54">
              {t('footer.connect')}
            </h3>
            <div className="flex space-x-4 mb-5" data-id="element-55">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="p-2 bg-gray-800 rounded-full hover:bg-primary-600 transition-colors" aria-label="Facebook" data-id="element-56">
                <Facebook className="h-4 w-4" data-id="element-57" />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="p-2 bg-gray-800 rounded-full hover:bg-primary-600 transition-colors" aria-label="Twitter" data-id="element-58">
                <Twitter className="h-4 w-4" data-id="element-59" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="p-2 bg-gray-800 rounded-full hover:bg-primary-600 transition-colors" aria-label="Instagram" data-id="element-60">
                <Instagram className="h-4 w-4" data-id="element-61" />
              </a>
            </div>
            <div className="text-sm space-y-2" data-id="element-62">
              <Link to="/privacy" className="block hover:text-primary-400" data-id="element-63">
                {t('footer.privacyPolicy')}
              </Link>
              <Link to="/privacy" className="block hover:text-primary-400" data-id="element-64">
                {t('footer.termsOfService')}
              </Link>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-6 pt-5" data-id="element-65">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 text-sm text-gray-500" data-id="element-66">
            <div data-id="element-67">
              <p className="mb-1" data-id="element-68">
                {t('footer.copyright').replace('{year}', currentYear.toString())}
              </p>
              <p className="text-xs" data-id="element-69">{t('footer.charity')}</p>
            </div>
            <div className="text-left text-sm" data-id="element-70">
              <p className="font-medium text-gray-400" data-id="element-71">
                Khyber Medical Association UK
              </p>
              <p className="text-xs text-gray-500" data-id="element-72">Registered Charity</p>
              <p className="text-xs text-gray-500" data-id="element-73">Charity Number: 1097262</p>
              <p className="text-xs text-gray-500" data-id="element-74">Registered: 1995</p>
            </div>
          </div>
          <div className="mt-4 pt-4 border-t border-gray-800 flex items-center justify-center gap-2 text-xs text-gray-500" data-id="element-75">
            <span data-id="element-76">Website made by</span>
            <a href="https://bright-pixxel.com/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 hover:text-gray-300 transition-colors" data-id="element-77">
              <img src="https://cdn.magicpatterns.com/uploads/pSNir5uWLUK49VBoZ4Cnmv/Untitled_design.jpg" alt="Bright Pixxel Studio" className="h-5 w-5 rounded object-contain" data-id="element-78" />
              <span className="font-medium text-gray-400" data-id="element-79">Bright Pixxel</span>
            </a>
          </div>
        </div>
      </div>
    </footer>;
}